import type { AssistantConversationListItem } from "../../types";

export type ConversationPartition = {
  /** Working or needs-you — the conversations something is happening in. */
  active: AssistantConversationListItem[];
  /** Everything else, in the order the backend gave it. */
  recent: AssistantConversationListItem[];
};

/**
 * Split a conversation list into the design's two groups.
 *
 * **Order inside each group is the backend's** (pinned first, then activity descending). This
 * is deliberate and load-bearing: the panel's old history tab re-sorted client-side by
 * `lastActivityAt` and silently threw the pinned-first order away, so a pinned conversation
 * fell down the list the moment anything else was touched. Partitioning is the only thing
 * this function is allowed to do.
 */
export function partitionConversations(
  items: readonly AssistantConversationListItem[]
): ConversationPartition {
  const active: AssistantConversationListItem[] = [];
  const recent: AssistantConversationListItem[] = [];

  for (const item of items) {
    if (item.status === "working" || item.status === "needs_you") {
      active.push(item);
    } else {
      recent.push(item);
    }
  }

  return { active, recent };
}
